angular.module('unergie.main')
.filter('frAmount', () =>
    function (val, precision) {
        if (_.isNaN(Number(val))) {
            return val
        }
        const p = precision === undefined ? 2 : precision
        const m = Math.pow(10, p)
        const v = Math.round(parseFloat(val) * m) / m
        let result = v.toLocaleString('fr-FR', { minimumFractionDigits: p })
        result = result === '-0,00' ? '0,00' : result
        return result
    }
)
